import axios from 'axios'

export const handleDownload = async (file: { url: string; name?: string; fileName?: string }) => {
  axios({
    url: file.url,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', file.name || file.fileName || new Date().toString())
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  })
}


export const handleDownloadTem = async () => {
  axios({
    url: "https://developmentreachwaremvp.blob.core.windows.net/reachware-attachments/eRvOjdz_pqqs_wJ7kfT2G.xlsx",
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', "reachwareData.xlsx" || "reachwareData.xlsx" || new Date().toString())
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  })
}

export const handleDownloadAgreement = async (url_attach: string , name : string) => {
  axios({
    url: url_attach ,
    method: 'GET',
    responseType: 'blob',
  }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `${name}.xlsx`  || new Date().toString())
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  })
}
